import { Invoices } from "@/app/report/invoices";
import { Transactions } from "@/app/report/transactions";
import { Statements } from "@/app/report/statements";

import { Scroll, Receipt, Book, Wallet, TrendingUp, UploadCloud } from "lucide-react";
import { FC, JSX } from "react";
import { Accounts } from "@/app/report/accounts";
import { Reports } from "@/app/report/reports";
import { Uploads } from "@/app/report/uploads";

const DEFAULT_ROUTE = process?.env?.NEXT_PUBLIC_DEFAULT_ROUTE || "transactions";
const DEFAULT_ROUTE_PATHS =
  process?.env?.NEXT_PUBLIC_DEFAULT_ROUTE_PATHS?.split(",") || ["/", "/report"];

const iconSize = 18;
const iconStrokeWidth = 2;

interface MenuItem {
  path: string;
  page: string;
  title: string;
  icon: JSX.Element;
  component: FC;
}

const operationalMenu: ReadonlyArray<MenuItem> = [
  {
    path: '/transactions',
    page: "transactions",
    title: "Transactions",
    icon: <Scroll size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Transactions
  },
  {
    path: '/invoices',
    page: "invoices",
    title: "Invoices",
    icon: <Receipt size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Invoices
  },
  {
    path: '/statements',
    page: "statements",
    title: "Statements",
    icon: <Book size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Statements
  },
];

const utilityMenu: ReadonlyArray<MenuItem> = [
  {
    path: '/accounts',
    page: "accounts",
    title: "Accounts",
    icon: <Wallet size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Accounts
  },
  {
    path: '/reports',
    page: "reports",
    title: "Reports",
    icon: <TrendingUp size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Reports
  },
  {
    path: '/uploads',
    page: "uploads",
    title: "Uploads",
    icon: <UploadCloud size={iconSize} strokeWidth={iconStrokeWidth} />,
    component: Uploads
  },
];

const menus = [...operationalMenu, ...utilityMenu];

export { DEFAULT_ROUTE, DEFAULT_ROUTE_PATHS, operationalMenu, menus, utilityMenu };
export type { MenuItem}